import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { useToast } from "@wato/ui";

export const GOOGLE_ROOT_FLAG = "google";

/** OWN-306: a Google callback with an unreadable state lands on `/?google=error|denied`; say so once. */
export function GoogleRootFlagToast() {
  const { t } = useI18n();
  const toast = useToast();
  const [params, setParams] = useSearchParams();
  const flag = params.get(GOOGLE_ROOT_FLAG);
  useEffect(() => {
    if (flag !== "error" && flag !== "denied") return;
    toast.show({ tone: "error", title: t("integrations.b29google.rootFlag") });
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(GOOGLE_ROOT_FLAG);
        return next;
      },
      { replace: true },
    );
  }, [flag, toast, t, setParams]);
  return null;
}
